import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import moment from 'moment';
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import { GameHistory } from 'actions/actionTypes';
import * as actions from 'actions/gameHistory/list';

import { callGameHistoryList } from 'network/apis/gameHistory/list';
import texts from 'assets/locale/texts';

function* loadGameHistoryListRequestSaga() {
  try {
    const gameHistory = yield select((state) => state.gameHistory);

    var data = {
      page: gameHistory.searchFilter.page,
      pageSize: gameHistory.searchFilter.pageSize,
      startDate: `${
        gameHistory.searchFilter.startDate
      }T00:00:00${moment().format('Z')}`,
      endDate: `${gameHistory.searchFilter.endDate}T23:59:59${moment().format(
        'Z'
      )}`,
      gameType: gameHistory.searchFilter.gameType,
      clientGuid: gameHistory.searchFilter.clientGuid,
      userNickname: gameHistory.searchFilter.userNickname,
    };

    const response = yield call(callGameHistoryList, data);

    yield put(actions.loadGameHistoryListSuccess(response.data));
  } catch (error) {
    yield put(actions.loadGameHistoryListFailure(error.message));
  }
}

function* loadGameHistoryExcelRequestSaga({ afterClickDownload }) {
  try {
    const gameHistory = yield select((state) => state.gameHistory);
    const language = yield select((state) => state.language);

    const text = texts[language.currentLanguage];
    const data = {
      startDate: `${
        gameHistory.searchFilter.startDate
      }T00:00:00${moment().format('Z')}`,
      endDate: `${gameHistory.searchFilter.endDate}T23:59:59${moment().format(
        'Z'
      )}`,
      gameType: gameHistory.searchFilter.gameType,
      clientGuid: gameHistory.searchFilter.clientGuid,
      userNickname: gameHistory.searchFilter.userNickname,
    };

    const response = yield call(callGameHistoryList, data);

    const excelFileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const excelFileExtension = '.xlsx';
    const excelFileName = `${moment().format('YYYYMMDD')}_게임내역`;

    const excelHead = XLSX.utils.aoa_to_sheet([
      [`게임내역`],
      [],
      [
        text.gameHistory.gameNumbers,
        text.gameHistory.clientName,
        text.gameHistory.gameType,
        text.gameHistory.numberPlayers,
        text.gameHistory.numberHolesCompleted,
        text.gameHistory.startDate,
        text.gameHistory.endDate,
      ]
    ])
    response.data.list.map((data: any) => {
      XLSX.utils.sheet_add_aoa(
          excelHead,
          [
            [
              data.gameRoundId,
              data.clientName,
              data.gameType,
              data.playerCount,
              data.completeHoleCount,
              moment(data.startTime).format('YYYY-MM-DD HH:mm'),
              `${data.endTime == null ? '-' : moment(data.endTime).format('YYYY-MM-DD HH:mm')}`,
            ]
          ],
          {origin: -1}
      );
      excelHead['!cols'] = [
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
      ]
      return false;
    });

    const wb: any = {Sheets: { data: excelHead }, SheetNames: ['data']};
    const excelButter = XLSX.write(wb, { bookType: 'xlsx', type: 'array'});
    const excelFile = new Blob([excelButter], { type: excelFileType});
    FileSaver.saveAs(excelFile, excelFileName + excelFileExtension);

    afterClickDownload();
    // yield put(actions.loadGameHistoryExcelSuccess(response.data));
  } catch (error) {
    yield put(actions.loadGameHistoryExcelFailure(error.message));
  }
}

// Sign-In Sagas
export default function* root() {
  yield all([
    takeLatest(
      GameHistory.LOAD_GAME_HISTORY_LIST_REQUEST,
      loadGameHistoryListRequestSaga
    ),
    takeLatest(
      GameHistory.LOAD_GAME_HISTORY_EXCEL_REQUEST,
      loadGameHistoryExcelRequestSaga
    ),
  ]);
}
